import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.CUSTOM_SLA,
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-sla'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'custom_sla_wrapper',
          meta,
          redirect: to => {
            return { name: 'custom_sla_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'custom_sla_list',
          meta,
          component: Index,
        },
      ],
    },
  ],
};
